import { render, staticRenderFns } from "./GovernoratesForm.vue?vue&type=template&id=58225fb4"
import script from "./GovernoratesForm.vue?vue&type=script&lang=js"
export * from "./GovernoratesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports